import React, { useEffect, useState } from "react";
import icon_comunicado from "../../../assets/vw/svg/comunicados.svg";
import icon_comunicado_active from "../../../assets/vw/svg/comunicados_azul.svg";
import icon_personalizado from "../../../assets/vw/svg/personalizado.svg"
import icon_personalizado_active from "../../../assets/vw/svg/personalizado_azul.svg"
import icon_lista from "../../../assets/vw/svg/lista.svg"
import icon_lista_active from "../../../assets/vw/svg/lista_azul.svg"
import Menu from "../../../components/Menu";
import DropdownSearch from "../../../components/DropdownSearch";
import Loading from "../../../components/Loading";
import success_icono from "../../../assets/vw/svg/check-exito.svg";
import error_icono from "../../../assets/vw/svg/check-error.svg";
import cerrar from "../../../assets/vw/svg/cerrar.svg";
import InputText from "../../../components/InputText";
import TextArea from "../../../components/TextArea";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import ARCH_AZUL from "../../../assets/vw/svg/archivo_azul.svg";
import DatePickerComponent from "../../../components/DatePicker";
import Tabla from "./Tabla/index";
import TablaArchivo from "./TablaInactivos";
/** @typedef {import("react-router-dom").RouteComponentProps} RouteComponentProps */
/**
 * @typedef {Object} Aplicacion
 * @property {number} idApp
 * @property {string} nombre
 */

/**
 * @param {RouteComponentProps} props
 * @returns {JSX.Element}
 */
export default function Comunicados(props) {
  const backendUrl = process.env.REACT_APP_URL_DTO_BACK;
  const api = backendUrl + "comunicados";
  const apiNotificaciones = backendUrl + "notificaciones?idNotificacion_2=" + process.env.REACT_APP_ID_NOTIFICACION;
  const initialFormData = {
    idApp: 0,
    titulo: "",
    mensaje: "",
    nombreApp: "",
    numComunicado: "",
  };
  const initialFormDataP = {correos: ""}

  // ADMINISTRACION
  const [dataRecordatorios, setDataRecordatorios] = useState([]);
  const [recordatorio, setRecordatorio] = useState([]);
  const [recordatoriosInactivas, setRecordatoriosInactivas] = useState([]);
  const [inactivasFilter, setInactivasFilter] = useState([]);
  const [dataOriginal, setDataOriginal] = useState([])
  // ENVIOS
  const [aplicaciones, setAplicaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [option, setOption] = useState("comunicados")
  const [template, setTemplate] = useState("");
  const [templatePersonalizado, setTemplatePersonalizado] = useState("");
  const [templateComunicado, setTemplateComunicado] = useState("");
  const [emailPreview, setEmailPreview] = useState("");
  const [mostrarModal, setMostrarModal] = useState(false);
  const [successArchivar, setSuccessArchivar] = useState(false);
  const [errorArchivar, setErrorArchivar] = useState(false);
  const [mensaje, setMensaje] = useState("Los cambios fueron guardados.");
  const [formDataP, setFormDataP] = useState(initialFormDataP);
  const [formData, setFormData] = useState(initialFormData);

  async function getAplicaciones() {
    try {
      const response = await fetch(backendUrl + "aplicacion?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        setMensaje("Hubo un error al guardar los cambios. " + data.mensaje);
        setLoading(false);
        setErrorArchivar(true);
        setMostrarModal(true);
        setSuccessArchivar(false);
        return;
      }

      setAplicaciones(data.mensaje);
    } catch (error) {
      setMensaje("Hubo un error al guardar los cambios. " + error.message);
      setLoading(false);
      setErrorArchivar(true);
      setMostrarModal(true);
      setSuccessArchivar(false);
    }
  }

  async function enviarComunicado(e) {
    e.preventDefault();
    setLoading(true);
  
    try {
      const isComunicado = option === "comunicados";
      const isPersonalizado = option === "personalizados";
  
      let bodyData;
      let mensajeExito;
      let mensajeError;
  
      if (isComunicado) {
        bodyData = formData;
        mensajeExito = "Comunicado enviado.";
        mensajeError = "Hubo un error al enviar el comunicado.";
      } else if (isPersonalizado) {
        const correos = obtenerDestinatarios(formDataP.correos);
        bodyData = { correos };
        mensajeExito = "Comunicado personalizado enviado.";
        mensajeError = "Hubo un error al enviar el comunicado personalizado.";
      }
      bodyData = Object.fromEntries(
        Object.entries(bodyData).filter(([key, value]) => value !== null)
      );
      const response = await fetch(api, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + props.servicio.getToken(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });
  
      const data = await response.json();
      setLoading(false);
      setMostrarModal(true);
      if (response.ok) {
        setMensaje(data.mensaje);
        setSuccessArchivar(true);
        setErrorArchivar(false);
      } else {
        setMensaje(`${mensajeError} ${data.mensaje}`);
        setSuccessArchivar(false);
        setErrorArchivar(true);
      }
    } catch (error) {
      setMensaje("Hubo un error. " + error);
      setLoading(false);
      setErrorArchivar(true);
      setMostrarModal(true);
      setSuccessArchivar(false);
    } finally {
      setLoading(false);
    }
  }

  const obtenerDestinatarios = (cadena) => {
    const correos = cadena.split(';').map(correo => correo.trim());
    correos.forEach(correo => {
      if (!validarCorreo(correo)) {
        throw new Error(`Correo inválido: ${correo}`);
      }
    });
    return correos;
  }
  
  const validarCorreo = (correo) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return regex.test(correo);
  }
  
  const buildPopUp = () => {
    return (
      <div
        className={`modal modal_vw modal_popup_vw fade ${mostrarModal ? "show" : ""}`}
        id="archivar"
        data-keyboard="false"
        data-backdrop="static"
        tabIndex="-1"
        aria-labelledby="archivarLabel"
        style={mostrarModal ? { display: "block" } : {}}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal_popup_content">
          <div className="modal-content modal_content-vw">
            <div className="modal-header modal_header-vw">
              <div className="d-flex justify-content-end">
                <button
                  className="button_icon-vw"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setMostrarModal(false);
                    // eslint-disable-next-line no-restricted-globals
                    location.reload(true);
                  }}
                >
                  <img src={cerrar} alt="cerrar"></img>
                </button>
              </div>
            </div>
            <div className={`modal-body p-3 p-sm-5 p-lg-5`}>{buildContent()}</div>
          </div>
        </div>
      </div>
    );
  };

  const buildContent = () => {
    return (
      <>
        {successArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={success_icono}
                className="icono-mensaje"
                alt="exito"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">{mensaje}</label>
          </div>
        ) : errorArchivar ? (
          <div className="mt-0 mt-lg-2 px-2 mensaje_confirmacion mb-0 mb-sm-5">
            <div className="d-flex justify-content-center">
              <img
                src={error_icono}
                className="icono-mensaje"
                alt="error"
              ></img>
            </div>
            <label className="popup_title popup_title--status d-flex justify-content-center">{mensaje}</label>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };

  const loadTemplate = async () => {
    setLoading(true);
    try {
      // COMUNICADO
      const responseComunicado = await fetch("/comunicado-template.html");
      const newTemplate = await responseComunicado.text();
      setTemplate(newTemplate)
      setTemplateComunicado(newTemplate)
      //PERSONALIZADO
      const responsePersonalizado = await fetch(apiNotificaciones, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${props.servicio.getToken()}`,
          "Content-Type": "application/json",
        },
      });
      if (!responsePersonalizado.ok) throw new Error('Error al cargar las notificaciones.');
      const { mensaje } = await responsePersonalizado.json();
      if (mensaje && mensaje.length > 0) {
        setTemplatePersonalizado(mensaje[0].plantilla);
      } else {
        throw new Error('No se encontró la plantilla.');
      }
    } catch (error) {
      setMensaje("Hubo un error. " + error);
      setLoading(false);
      setErrorArchivar(true);
      setMostrarModal(true);
      setSuccessArchivar(false);      
    } finally {
      setLoading(false);
    }
  }

  const changeOption = (option) => {
    setOption(option)
    if (option === "archivo") {
      getRecordatoriosInactivos(dataOriginal);
    }
  };

  const getRecordatoriosInactivos = (data) => {
    const inactivas = data.filter((canal) => {
      return canal.activo === 0;
    });
    setRecordatoriosInactivas(inactivas);
  };

  const getRecordatorios = async () => {

    try {
      setLoading(true);
      const response = await fetch(api,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + props.servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error("Error en el feching de recordatorios" + data.mensaje);
      }

      setDataOriginal(data.mensaje)
      const activas = data.mensaje.filter((recordatorio) => {
        return recordatorio.activo === 1;
      });
      setDataRecordatorios(activas);
    } catch (error) {
      console.error(error.stack || error)
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setRecordatorio([])
    setInactivasFilter([])
    if (option === "archivo") {
      filtrarInactivas(e.target.value)
    } else {
      filtrar(e.target.value);
    }

  };

  const handleDateChange = (date) => {
    let fecha;
    let fechaSoloFecha = null;

    if(date !== null){
      fecha = new Date(date);
      fechaSoloFecha = fecha.toISOString().slice(0, 10);
    }

    setFormData((prevData) => ({
      ...prevData,
      fecha_envio: fechaSoloFecha
    }));
  };

  const filtrar = (terminoBusqueda) => {
    const resultado = dataRecordatorios.filter((element) => {
      if (
        element.nombre.toLowerCase().includes(terminoBusqueda.toLowerCase())
      ) {
        return element;
      }
      return "";
    });
    setRecordatorio(resultado);
  };

  const filtrarInactivas = (terminoBusqueda) => {
    const resultado = recordatoriosInactivas.filter((element) => {
      if (
        element.nombre.toLowerCase().includes(terminoBusqueda.toLowerCase())
      ) {
        return element;
      }
      return "";
    });
    setInactivasFilter(resultado); 
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        await getAplicaciones()
        await getRecordatorios()
        await loadTemplate()
      } catch (error) {
        console.error('Error durante la carga:', error.stack || error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  useEffect(() => {
    setFormData(initialFormData);
    setFormDataP(initialFormDataP);
    const templates = {
      comunicados: templateComunicado,
      personalizados: templatePersonalizado
    };
    setTemplate(templates[option] || null);
  }, [option]);
  
  useEffect(() => {    
    let preview = template;
    Object.entries(formData).forEach(([key, value]) => {
      const stringValue = value?.toString();
  
      if (stringValue !== "" && stringValue !== "0") {
        preview = preview.replace(`{${key}}`, `${value}`);
      }
    });
    setEmailPreview(preview);
  }, [formData, template]);


  return (
    <>
      {buildPopUp()}
      <Menu />
      {loading && <Loading />}
      <div className="navegacion comunicados-section">
        <div className="posicionMenu">
          <ul className="d-flex flex-row px-0 my-0">
            {["comunicados", "personalizados", "lista", "archivo"].map((optionName) => (
              <li 
                key={optionName}
                className="opcion-ruta normal_width"
                onClick={() => changeOption(optionName)}
              >
                <div className={`nav-link nav-link-title active ps-0 ${option === optionName ? " active border_menu" : ""}`}>
                <img
                  src={(option === optionName ? 
                    { comunicados: icon_comunicado_active, 
                      personalizados: icon_personalizado_active, 
                      lista: icon_lista_active,
                      archivo: ARCH_AZUL
                    }[optionName] : 
                    { comunicados: icon_comunicado, 
                      personalizados: icon_personalizado, 
                      lista: icon_lista,
                      archivo: ARCH
                    }[optionName])}
                  alt="accesos"
                  className="icono-menu me-3"
                />
                  {optionName.charAt(0).toUpperCase() + optionName.slice(1)}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="row border_vw pt-4 ms-0 mx-0"></div>
        {/* Renderizado para envio de comunicados */}
        { (option === "comunicados" || option === "personalizados") && (
        <div className="row mb-5 mb-lg-0 m-0">
          <div className="col-12 col-lg-6 mb-5 mb-lg-0 p-0 p-lg-3">
            <div className="row posicionMenu">
              <div className="titulo_vw p-0">Contenido</div>
            </div>
            <form onSubmit={enviarComunicado}>
              {/* Comunicados */}
              {option === "comunicados" && (
                <>
                  <div className="mt-4">
                    <DropdownSearch
                      menu={aplicaciones}
                      title={"Aplicación"}
                      defaultValue={formData.idApp}
                      handleOptionSelected={(e) => setFormData({
                        ...formData,
                        idApp: parseInt(e.props.value),
                        nombreApp: e.props.children,
                      })}
                      fieldID={'idApp'}
                      fieldToShow={'nombre'}
                    />
                  </div>
                  <div className="mt-4">
                    <InputText
                      inputLabel="Número de comunicado (XXX-XXXXXX)"
                      inputField={formData.numComunicado}
                      id="numComunicado"
                      changingInput={(event) => setFormData({
                        ...formData,
                        numComunicado: event.target.value,
                      })}
                      required
                      extraStyle="change_color_negro"
                    />
                  </div>
                  <div className="mt-4">
                    <InputText
                      inputLabel="Título"
                      id="titulo"
                      inputField={formData.titulo}
                      changingInput={(event) => setFormData({
                        ...formData,
                        titulo: event.target.value,
                      })}
                      required
                      extraStyle="change_color_negro"
                    />
                  </div>
                  <div className="mt-4">
                    <TextArea
                      inputLabel="Mensaje"
                      id="mensaje"
                      inputField={formData.mensaje}
                      changingInput={(event) => setFormData({
                        ...formData,
                        mensaje: event.target.value,
                      })}
                      required
                      rows={10}
                      extraStyle="change_color_negro"
                    />
                  </div>
                  <div className="mt-4 form-control-input">
                  <DatePickerComponent
                    onDateChange={handleDateChange}
                    inputLabel="Programar reenvío"
                    id="reenvio"
                    inputField={formData.fecha_envio}
                  />
                </div>

                  <div className="mt-4"></div>
                </>
              )}

              {/* Personalizados */}
              {option === "personalizados" && (
                <div className="mt-4">
                  <InputText
                    inputLabel="Correo(s)"
                    inputField={formDataP.correos}
                    id="correos"
                    changingInput={(event) => setFormDataP({
                      ...formDataP,
                      correos: event.target.value,
                    })}
                    required
                    extraStyle="change_color_negro"
                  />
                </div>
              )}

              {/* Lista */}
              {option === "lista" && (
                <div className="mt-4">
                  <p>Este es el contenido para la opción "Lista".</p>
                </div>
              )}

              {/* Archivo */}
              {option === "archivo" && (
                <div className="mt-4">
                  <p>Este es el contenido para la opción "Archivo".</p>
                </div>
              )}
              <div className="preview-comunicados-mobile col-12 col-lg-6 change_color_negro p-3">
                <div className="row posicionMenu my-3">
                  <div className="titulo_vw p-0 mb-3">Vista previa</div>
                </div>
                {(option === "comunicados") ? (                <div className="px-4 pb-5">
                  <iframe
                    srcDoc={emailPreview}
                    style={{ width: "100%", height: "100vh" }}
                    title="Vista previa"
                    sandbox=""
                  />
                </div>) : (                <div className="px-4 pb-5">
                  <iframe
                    srcDoc={emailPreview}
                    style={{ width: "100%", height: "100vh" }}
                    title="Vista previa"
                    sandbox=""
                  />
                </div>)}
              </div>
              <div className="d-flex justify-content-center pt-2 mt-4 mt-lg-0 mb-4 mb-lg-0">
                <button 
                  type="submit" 
                  className="button_vw button_vw--primary"
                  disabled={option === "comunicados" ? aplicaciones.length === 0 || formData.idApp === 0 : formDataP.correos.trim() === ""}
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>
          <div className="preview-comunicados-desktop col-12 col-lg-6 change_color_negro p-3">
            <div className="row posicionMenu my-3">
              <div className="titulo_vw p-0 mb-3">Vista previa</div>
            </div>
            <div className="px-4 pb-5">
              <iframe
                srcDoc={emailPreview}
                style={{ width: "100%", height: "100vh" }}
                title="Vista previa"
                sandbox=""
              />
            </div>
          </div>
        </div>
        )}
        {/* Renderizado para administracion de comunicados */}
        { (option === "lista" || option === "archivo") && (
          <div className="col-12 p-0 contenedor-table">
          {option === "archivo" ? (
            <TablaArchivo
              servicio={props.servicio} recordatorios={inactivasFilter && inactivasFilter.length > 0 ? inactivasFilter : recordatoriosInactivas} aplicaciones = {aplicaciones} preview = {templateComunicado} handleChange={handleChange}
            />
          ) : (
            <Tabla
              servicio={props.servicio} recordatorios={recordatorio && recordatorio.length > 0 ? recordatorio : dataRecordatorios} aplicaciones = {aplicaciones} preview = {templateComunicado} handleChange={handleChange}
            />
          )}
          </div>
        )}
      </div>
    </>
  );
}
